module.exports = __webpack_public_path__ + "static/media/movies-icon.85772906.svg";